$(document).on('turbolinks:load', function() {
    $('#add').click(function() {
        window.location.href = $(this).data("url");
    });
});